/*
 *
 * Students constants
 *
 */

export const FLUSH_STATE = 'app/Students/FLUSH_STATE';

export const LOAD_STUDENTS = 'app/Students/LOAD_STUDENTS';
export const LOAD_STUDENTS_SUCCESS = 'app/Students/LOAD_STUDENTS_SUCCESS';
export const LOAD_STUDENTS_ERROR = 'app/Students/LOAD_STUDENTS_ERROR';

export const UPDATE_STUDENT = 'app/Students/UPDATE_STUDENT';
export const UPDATE_STUDENT_SUCCESS = 'app/Students/UPDATE_STUDENT_SUCCESS';
export const UPDATE_STUDENT_ERROR = 'app/Students/UPDATE_STUDENT_ERROR';
